import type React from 'react'
import { cn } from '@/lib/utils'
import { ArgusLogo } from '../decorative/argus-logo'
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from './card'

export function PageCard({
  title,
  description,
  containerClassName,
  cardClassName,
  footer,
  children,
}: {
  title: string
  /** Omit it when it would only restate the title. */
  description?: React.ReactNode
  containerClassName?: string
  cardClassName?: string
  footer?: React.ReactNode
  children?: React.ReactNode
}) {
  return (
    <div className="px-4 sm:px-8 flex justify-center">
      <div className="py-6 sm:py-10 w-full max-w-112 flex items-center justify-center min-h-svh">
        <Card className={cn('w-full flex flex-col', cardClassName)}>
          <CardHeader>
            <ArgusLogo width={42} height={26} />
            <CardTitle className="mt-6">{title}</CardTitle>
            {description && <CardDescription>{description}</CardDescription>}
          </CardHeader>
          <CardContent className={containerClassName}>{children}</CardContent>
          {footer && <CardFooter className="justify-center">{footer}</CardFooter>}
        </Card>
      </div>
    </div>
  )
}
